import { useMemo, useState } from "react";
import Accordion from "../../../components/accordian";
import { useTranslation } from "react-i18next";
import { permitToWorkUndertakings, USER_ROLES_IDS } from "../../../constants/common";
import useAuthStore from "../../../store/Auth";
import { APP_ROUTES } from "../../../routes";
import { useLocation } from "react-router-dom";

const Undertakings = () => {
  const { t } = useTranslation();

  const [selectedKey, setSelectedKey] = useState<string>("1");

  const { user } = useAuthStore()

  const location = useLocation();

  const isApprovePermitPage = useMemo(
    () => location.pathname === APP_ROUTES.APPROVE_PERMIT_TO_WORK,
    [location.pathname],
  );

  return (
    <>
      {user?.n_RoleID !== USER_ROLES_IDS.ADMIN && !isApprovePermitPage && (
        <div className="bg-white z-10 p-2 md:p-4 rounded-xl flex flex-col gap-3 lg:gap-6 shadow-[0px_1px_5px_0px_rgba(113,112,163,0.3)]">
          <Accordion
            id="1"
            selectedKey={selectedKey}
            onSelectionChange={setSelectedKey}
            title={
              <h1 className="text-xl md:text-2xl flex flex-1 -mt-2 items-center">
                {t("undertakings")}
              </h1>
            }
          >
            <div className="flex flex-col gap-2 lg:gap-4">
              <ul className="list-disc list-inside">
                {permitToWorkUndertakings.map((item) => (
                  <li key={item} className="text-sm">
                    {t(item)}
                  </li>
                ))}
              </ul>
            </div>
          </Accordion>
        </div>
      )}
    </>
  );
};

export default Undertakings;
